import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ArchiveSectorDialogComponent, ArchiveSectorDialogData, ArchiveSectorDialogResult } from './archive-sector-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ArchiveSectorDialogService {
  constructor(private matDialog: MatDialog) {}

  public open(data: ArchiveSectorDialogData): Promise<ArchiveSectorDialogResult> {
    return this.matDialog.open<ArchiveSectorDialogComponent, ArchiveSectorDialogData, ArchiveSectorDialogResult>(ArchiveSectorDialogComponent, {
      autoFocus: false,
      data: data
    }).afterClosed()
      .toPromise();
  }
}
